import styled from 'styled-components';
import { Subtitle2Font } from '../../../themes/fonts';
import { THEME } from '../../../themes';
import { hexToRgbA } from '../../../utils/colors';

export const TagContainer = styled.div`
  ${Subtitle2Font};
  padding: ${THEME.SPACING.MICRO} ${THEME.SPACING.TINY};
  border-radius: ${THEME.RADIUS.TIDY};
  border: solid 1px ${hexToRgbA(THEME.COLORS.PRIMARY_DARK, THEME.OPACITY.GHOST)};
  display: inline-flex;
  width: fit-content;
  align-items: center;
  gap: ${THEME.SPACING.MICRO};
  :hover {
    & svg {
      fill: currentColor; 
    }
  }
`;
